'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationMonitoring', ['$scope', 'Permissions', 'ComplaintMonitoring', '$q', function ($scope, Permissions, ComplaintMonitoring, $q) {
        $scope.resetInvestigation();
        $q.all([
            Permissions.edit("internal.licensing.investigation.monitoring"),
            Permissions.delete("internal.licensing.investigation.monitoring")
        ]).then(function (permissions) {
            if (permissions && permissions.length === 2) {
                $scope.hasEditPermission = permissions[0];
                $scope.hasDeletePermission = permissions[1];
            }
        });

        $scope.save = function(complaint_action) {
            complaint_action.editing = false;
            complaint_action.saving = true;

            ComplaintMonitoring.save(complaint_action).then(function(complaint_monitoring) {
                complaint_action.id = complaint_monitoring.id;
                updateArray($scope.masterInvestigation.complaint_monitoring, complaint_monitoring);
                updateArray($scope.investigation.complaint_monitoring, complaint_monitoring);
                complaint_action.saving = false;
            });
        }

        $scope.delete = function(complaint_action) {
            complaint_action.editing = false;
            complaint_action.deleting = true;

            if (window.confirm('Are you sure you want to delete this action?')) {
                ComplaintMonitoring.delete(complaint_action.id).then(function() {
                    updateArray($scope.investigation.complaint_monitoring, complaint_action, true);
                    updateArray($scope.masterInvestigation.complaint_monitoring, complaint_action, true);
                    complaint_action.deleting = false;
                })
            }
            else {
                complaint_action.deleting = false;
            }
        }

        $scope.add = function(array) {
            array.push({ complaint_id: $scope.investigationID, editing: true });
        }

        $scope.checkDue = function(complaint_action) {
            var due = false;
            var today = new Date();
            // if complaint_action.complete_date is NULL and complaint_action.due_date < now, set due = true
            if (complaint_action.due_date !== null && complaint_action.complete_date == null && complaint_action.due_date < today) {
                due = true;
            }
            return due;
        }
    }])
;